/**
 * Sends user profile data to Connector Grid, if available at a browser-level.
 * uID is a required data element that needs to be sent in this request.
 *
 * @async
 * @function
 * @name sendDataToConnectorGrid
 * @param {Object} userProfileData
 * @returns {Promise<void|any>} - A promise that resolves once user profile data is sent.
 *
 * @author Jaskiran Chhokar
 */

import { ResponseBody } from 'globalTypes';
import apiConfig from './apiConfig';
import connectorGridApiHeader from '../constants/connectorGridApiHeader.ts';

const sendDataToConnectorGrid = async (ResponseBody: ResponseBody, xCryptoKey?: string): Promise<any | null> => {
    try {
        // if SECURED.encrypted= true then the x-crypto-key should be updated
        const newHeader = { ...connectorGridApiHeader, ...(xCryptoKey ? { 'x-crypto-key': xCryptoKey } : '') };
        const response = await fetch(apiConfig.connectorGrid.sendData, {
            method: 'POST',
            headers: newHeader,
            body: JSON.stringify(ResponseBody),
        });
        if (!response.ok) {
            throw new Error(`Network request to Connector Grid failed! Received status code: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        const err = error as Error;
        console.error(`Error in sendDataToConnectorGrid: ${err.message || err}`);
    }
};

export default sendDataToConnectorGrid;
